import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUserApplyRecords from '@/types/table/platformUserApplyRecords';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserApplyRecordsData extends PlatformUserApplyRecords {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserApplyRecordsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserApplyRecordsData>>(API_CONTEXT + '/app/platformUserApplyRecords/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserApplyRecordsData>(API_CONTEXT + '/app/platformUserApplyRecords/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUserApplyRecords/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUserApplyRecords/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUserApplyRecords/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserApplyRecords/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserApplyRecords/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserApplyRecords/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserApplyRecords/deleteBatch', params, httpOptions);
  }
}
